/**
 * Review photo lightbox with full-gallery navigation (prev/next + swipe + keys).
 * Collects photos from Judge.me / Loox / generic [data-reviews-photo] in the reviews section.
 * Does not invent reviews — only enhances existing photo markup.
 */
(function () {
  const PHOTO_SELECTORS = [
    '[data-reviews-photo]',
    '.jdgm-rev__pic-img',
    '.jdgm-rev__pic-link img',
    '.jdgm-gallery img',
    '.jdgm-all-reviews-page__gallery-img',
    '.loox-review-image img',
    '.loox-gallery img',
    '.spr-review-header-image img',
  ].join(',');

  function collectPhotos(root) {
    const nodes = Array.from(root.querySelectorAll(PHOTO_SELECTORS));
    const seen = new Set();
    const photos = [];
    nodes.forEach((img) => {
      const src =
        img.currentSrc ||
        img.src ||
        img.getAttribute('data-src') ||
        img.getAttribute('data-original-src') ||
        '';
      if (!src || seen.has(src)) return;
      seen.add(src);
      photos.push({
        src,
        alt: img.getAttribute('alt') || 'Review photo',
        el: img,
      });
      img.setAttribute('data-reviews-photo-bound', '1');
      img.style.cursor = 'zoom-in';
    });
    return photos;
  }

  function initSection(section) {
    if (!section || section.dataset.reviewsPhotosInit === '1') return;
    section.dataset.reviewsPhotosInit = '1';

    const lightbox = section.querySelector('[data-reviews-lightbox]');
    if (!lightbox) return;

    const imgEl = lightbox.querySelector('[data-reviews-lightbox-img]');
    const captionEl = lightbox.querySelector('[data-reviews-lightbox-caption]');
    const emptyEl = section.querySelector('[data-reviews-empty]');
    let photos = [];
    let index = 0;
    let touchX = null;

    function refreshPhotos() {
      photos = collectPhotos(section);
      /* Hide empty state if app injected reviews */
      if (
        emptyEl &&
        (section.querySelector('.jdgm-rev') ||
          section.querySelector('.jdgm-rev-widg .jdgm-rev-widg__body') ||
          section.querySelector('.loox-review') ||
          section.querySelector('.spr-review'))
      ) {
        emptyEl.hidden = true;
        emptyEl.classList.add('product-reviews__empty--has-data');
      }
    }

    function openAt(i) {
      if (!photos.length) return;
      index = ((i % photos.length) + photos.length) % photos.length;
      const p = photos[index];
      imgEl.src = p.src;
      imgEl.alt = p.alt;
      if (captionEl) {
        captionEl.textContent =
          photos.length > 1 ? index + 1 + ' / ' + photos.length : '';
      }
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      imgEl.removeAttribute('src');
      document.documentElement.style.overflow = '';
    }

    function next(delta) {
      openAt(index + delta);
    }

    section.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const img = t.closest(PHOTO_SELECTORS);
      if (!img || !section.contains(img)) return;
      e.preventDefault();
      e.stopPropagation();
      refreshPhotos();
      const src =
        img.currentSrc ||
        img.src ||
        img.getAttribute('data-src') ||
        '';
      const i = photos.findIndex((p) => p.src === src);
      openAt(i >= 0 ? i : 0);
    });

    lightbox.querySelectorAll('[data-reviews-lightbox-close]').forEach((el) => {
      el.addEventListener('click', close);
    });
    const prevBtn = lightbox.querySelector('[data-reviews-lightbox-prev]');
    const nextBtn = lightbox.querySelector('[data-reviews-lightbox-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => next(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => next(1));

    document.addEventListener('keydown', (e) => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') next(-1);
      if (e.key === 'ArrowRight') next(1);
    });

    lightbox.addEventListener(
      'touchstart',
      (e) => {
        if (e.changedTouches && e.changedTouches[0]) {
          touchX = e.changedTouches[0].clientX;
        }
      },
      { passive: true }
    );
    lightbox.addEventListener(
      'touchend',
      (e) => {
        if (touchX == null || !e.changedTouches || !e.changedTouches[0]) return;
        const dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 40) return;
        next(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    /* Judge.me loads async — refresh photo list after settle */
    refreshPhotos();
    window.setTimeout(refreshPhotos, 1500);
    window.setTimeout(refreshPhotos, 4000);

    const host = section.querySelector('[data-reviews-app-host]');
    if (host && typeof MutationObserver !== 'undefined') {
      const mo = new MutationObserver(() => refreshPhotos());
      mo.observe(host, { childList: true, subtree: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-product-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
